import gql from "graphql-tag";

const getAllWorkLeave = gql`
  query($limit: Int, $page: Int, $status: String, $employeeId: ID) {
    getAllWorkLeave(
      paging: { limit: $limit, page: $page }
      filter: { status: $status, employeeId: $employeeId }
    ) {
      id
      totalLeaveDays
      totalLeaveHours
      status
      employee {
        id
        fullname
      }
      typeWorkLeave {
        id
        title
        benefit
      }

      typeWorkLeaveId
      createdAt
      updatedAt
    }
  }
`;

const getWorkLeave = gql`
  query($id: ID!) {
    getWorkLeave(id: $id) {
      id
      totalLeaveDays
      totalLeaveHours
      status
      description
      currentApprovalStep
      employee {
        id
        code
        fullname
        department {
          id
          name
        }
        position {
          id
          name
        }
      }
      workShift {
        id
        code
        title
        startTime
        endTime
        duration
        dayInWeeks
        description
      }
      typeWorkLeave {
        id
        title
        benefit
        limit
      }
      workLeaveDays {
        id
        startDate
        endDate
        totalLeaveDays
        totalLeaveHours
      }
      typeWorkLeaveId
      createdAt
      updatedAt
      author {
        id
        username
        fullname
      }
    }
  }
`;

const getApprovalWorkLeave = gql`
  query($id: ID!) {
    getWorkLeave(id: $id) {
      id
      totalLeaveDays
      totalLeaveHours
      status
      description
      currentApprovalStep
      workLeaveApprovals {
        id
        note
        approvalStatus
        createdAt
        approvalStep
        author {
          id
          fullname
          username
        }
      }
      employee {
        id
        code
        fullname
        department {
          id
          name
        }
        position {
          id
          name
        }
      }
      workShift {
        id
        code
        title
        startTime
        endTime
        duration
        dayInWeeks
        description
      }
      typeWorkLeave {
        id
        title
        benefit
        limit
      }
      workLeaveDays {
        id
        startDate
        endDate
        totalLeaveDays
        totalLeaveHours
      }
      typeWorkLeaveId
      createdAt
      updatedAt
      author {
        id
        username
        fullname
      }
    }
  }
`;

export default {
  getAllWorkLeave,
  getWorkLeave,
  getApprovalWorkLeave,
};
